import {Component, ViewChild} from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { SuperTabsComponent } from '../../components/ionic2-super-tabs/src/components/super-tabs';

import {XpUnitOverviewPage} from "../xp-unit-overview/xp-unit-overview";
import {XpUnitReportsPage} from "../xp-unit-reports/xp-unit-reports";
import {XpUnitInfoPage} from "../xp-unit-info/xp-unit-info";
import {XpUnitHistoryPage} from "../xp-unit-history/xp-unit-history";

@Component({
  selector: 'page-xp-unit',
  templateUrl: 'xp-unit.html',
})
export class XpUnitPage {

  @ViewChild('unitTabs') superTabs: SuperTabsComponent;

  unitOverviewPage = XpUnitOverviewPage;
  unitInfoPage = XpUnitInfoPage;
  unitHistoryPage = XpUnitHistoryPage;
  unitReportsPage = XpUnitReportsPage;

  unit: any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.unit = this.navParams.get('unit');
    console.log(this.unit);
  }

  onTabSelect(tab: { index: number; id: string; }) {
    console.log(`Selected tab: `, tab);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UnitPage');
  }

  public openReport(report){
    if(report.files && report.files.length){
      window.open(report.files[0].download_url);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-unit/xp-unit.ts